import { render, staticRenderFns } from "./tabulacao-list-professor.vue?vue&type=template&id=6df25351"
import script from "./tabulacao-list-professor.vue?vue&type=script&lang=js"
export * from "./tabulacao-list-professor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports